import styled from '@emotion/styled';
import UDLink from 'ud-ui/components/link';

export const SupportLink = styled(UDLink)`
  color: ${({ theme }) => theme.colors.DarkYellow};
`;
